import { render, staticRenderFns } from "./FitHuntModel.vue?vue&type=template&id=dca015c6&scoped=true"
import script from "./FitHuntModel.vue?vue&type=script&lang=js"
export * from "./FitHuntModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca015c6",
  null
  
)

export default component.exports